import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic_fav_hl",
  "use": "icon-ic_fav_hl-usage",
  "viewBox": "0 0 34 33",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34 33\" id=\"icon-ic_fav_hl\"><path d=\"m17 27.5-7.581 3.986a2 2 0 0 1-2.902-2.109l1.448-8.441-6.133-5.979a2 2 0 0 1 1.108-3.411l8.476-1.232 3.79-7.68a2 2 0 0 1 3.587 0l3.791 7.68 8.476 1.232a2 2 0 0 1 1.108 3.411l-6.133 5.979 1.448 8.441a2 2 0 0 1-2.902 2.109L17 27.5z\" fill=\"#FF5159\" stroke=\"#FF5159\" stroke-width=\"2\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol